import { useMemo } from 'react';

import type { ComponentId } from '@vgtv/api-client/lib/component';

import { useAppSelector } from '../../modules/hooks';
import { selectMixedForComponent } from '../../modules/components';
import { useVendor } from '../VendorPovider/VendorPovider';

export const useComponentMixed = (id: ComponentId) => {
  const { vendor } = useVendor();
  const mixed = useAppSelector((state) =>
    selectMixedForComponent(state, vendor, id)
  );
  const foundIds = mixed.map(({ id }) => id).join(',');

  // deliberately skipping entities in dependency list
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => mixed, [foundIds]);
};
